import React, { useState, useEffect, useMemo } from 'react';
import pisi from'../../images/pisi.png'
import Chat from '../chat/chat';
import Game from '../game/game';
import BlackScreen from '../blackScreen/blackScreen';
import GroupChat from '../groupChat/groupChat';
import Camera from '../camera/camera';
import images from '../../services/photos'
import plot from'../../services/plot'

function Play({currentDay, endPlay, gallery, setGallery, galleryWork, setGalleryWork}) {
  const [step, setStep] = useState( localStorage.getItem('step') === null? 0 : parseInt(localStorage.getItem('step')) );
  const [plotLine, setPlotLine] = useState( localStorage.getItem('plotLine') === null? 0 : parseInt(localStorage.getItem('plotLine')) );
  const [failedGame, setFailedGame] = useState( localStorage.getItem('failedGame') === null? 0 : parseInt(localStorage.getItem('failedGame')) );
  const [askCount, setAskCount] = useState( localStorage.getItem('askCount') === null ? 0 : parseInt(localStorage.getItem('askCount')) );
  const [mistakes, setMistakes] = useState( localStorage.getItem('mistakes') === null ? 0 : parseInt(localStorage.getItem('mistakes')) );

  function goNext(){
    localStorage.setItem('step', step+1);
    setStep(prev => prev+1);
  }

  function goNextOnI(i){
    localStorage.setItem('step', step+i);
    setStep(prev => prev+i);
  }

  if(plot.length<=step){
    localStorage.setItem('step', 0);
    setStep(0);
    return;
  }

  if(step !== undefined && currentDay[step].messages && currentDay[step].messagesAlt && !currentDay[step].groupChat){
      if(failedGame === 0){
        return (
      <Chat from={currentDay[step].from} mess={currentDay[step].messages} goNext={goNext} goNextOnI={goNextOnI} goMenu={endPlay} gallery={gallery} setGallery={setGallery} setFailedGame={setFailedGame}/>
    );
    }else if(failedGame === 1){
      return (
      <Chat from={currentDay[step].fromAlt} mess={currentDay[step].messagesAlt} goNext={goNext} goNextOnI={goNextOnI} goMenu={endPlay} gallery={gallery} setGallery={setGallery} setFailedGame={setFailedGame}/>
    );
    }
  }else if(step !== undefined && currentDay[step].messages && !currentDay[step].groupChat){
    return (
  <Chat from={currentDay[step].from} mess={currentDay[step].messages} goNext={goNext} goNextOnI={goNextOnI} goMenu={endPlay} gallery={gallery} setGallery={setGallery} setFailedGame={setFailedGame}/>
);
}else if(step !== undefined && currentDay[step].messages && currentDay[step].groupChat){
    return (
      <GroupChat from={currentDay[step].from} mess={currentDay[step].messages} goNext={goNext} goMenu={endPlay} setFailedGame={setFailedGame} gallery={gallery} setGallery={setGallery}/>
  );
  }

  if(step !== undefined && currentDay[step].game){
    return (
      <Game askCount={askCount} setAskCount={setAskCount} mistakes={mistakes} setMistakes={setMistakes} goNext={goNext} arr={currentDay[step].arr} answers={currentDay[step].answers} goForward={currentDay[step].goForward} ifIncorrect={currentDay[step].ifIncorrect} hints={currentDay[step].hints} ifGameFailed={currentDay[step].ifGameFailed} setFailedGame={setFailedGame} endPlay={endPlay} galleryWork={galleryWork} setGalleryWork={setGalleryWork}/>
  );
  }
  if(step !== undefined && currentDay[step].camera && currentDay[step].plotAlt){
      if(plotLine === 0){
        return (
          <Camera plot={currentDay[step].plot} prevBckImg={currentDay[step].prevBckImg} setPlotLine={setPlotLine} goNext={goNext} goNextOnI={goNextOnI} goMenu={endPlay} setFailedGame={setFailedGame} gallery={gallery} setGallery={setGallery}/>
        );
    }else if(plotLine === 1){
      return (
        <Camera plot={currentDay[step].plotAlt} prevBckImg={currentDay[step].prevBckImgAlt} setPlotLine={setPlotLine} goNext={goNext} goNextOnI={goNextOnI} goMenu={endPlay} setFailedGame={setFailedGame} gallery={gallery} setGallery={setGallery}/>
      );
    }
  }else if(step !== undefined && currentDay[step].camera && currentDay[step].plot){
    return (
      <Camera plot={currentDay[step].plot} prevBckImg={currentDay[step].prevBckImg} setPlotLine={setPlotLine} goNext={goNext} goNextOnI={goNextOnI} goMenu={endPlay} setFailedGame={setFailedGame} gallery={gallery} setGallery={setGallery}/>
    );
  }

  if(step !== undefined && currentDay[step].blkscrn){
    return (
      <BlackScreen txt={currentDay[step].txt} goNext={currentDay[step].end ? endPlay : goNext} end={currentDay[step].end} setMistakes={setMistakes} setPlotLine={setPlotLine} setFailedGame={setFailedGame} setAskCount={setAskCount} reset={currentDay[step].reset} resetFgameToFalse={currentDay[step].resetFgameToFalse} first={currentDay[step].first}/>
  );
  }

}

export default Play;
